import jwt from 'jsonwebtoken';
import jwkToPem from 'jwk-to-pem';
// var fs = require('fs');
import jwksJson from './jwks.json';
const jwk = jwksJson;

function base64decode(base64text){
    return Buffer.from(base64text, 'base64').toString('utf8');
}

// export function has_expire (token){
export default function(token){
   return new Promise((resorve, reject) => {

      if(!token) {
         return reject('token require param');
      }
      const sections = token.split('.');
      let header = base64decode(sections.find(section => typeof section === 'string'));
      header = JSON.parse(header);
      const kid = header.kid;
      let results = jwk.keys.find(jwk => jwk.kid == kid);
      var pem = jwkToPem(results);
      jwt.verify(token, pem, { algorithms: ['RS256'] }, function (err, decodedToken) {
         if(err) return reject(err.message);
         return resorve(decodedToken);
      });
   }) ;
};
